import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ErrorSummary} from '../../Molecules/ErrorsAndAlert/ErrorSummary/ErrorSummary'
import {MembersPageTemplate, MembersPageTemplateProps} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {Spacer} from '../../../../Common/Components/Spacer'

type MembersMobileCarrierMaintenancePageProps = Pick<MembersPageTemplateProps, 'bucketInfo'> & {
  pageTitle: string
  operationName: string
  buttonName?: string
  url?: string
}

// eslint-disable-next-line max-len
export const MembersMobileCarrierMaintenancePage: React.VFC<MembersMobileCarrierMaintenancePageProps> = (
  props
) => {
  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={props.bucketInfo}
    >
      <PageTitle>{props.pageTitle}</PageTitle>
      <ErrorSummary
        display={true}
        headline={`現在キャリア決済メンテナンス期間のため、\n${props.operationName}はできません。`}
        detail={'月末日19:00 ～ 翌月1日23:59:59\n入会(キャリア決済へ支払い変更)日当日 〜 翌日1:00'}
        testId={'mobile-carrier-maintenance-message'}
      />

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${props.buttonName ?? ''}に移動する`}
            url={props.url}
          />
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
